import { FileSaverService } from 'ngx-filesaver';
import { ToastrService, ToastrModule } from 'ngx-toastr';
import { HttpEventType, HttpClientModule } from '@angular/common/http';
import { throwError, timer, Subscription } from 'rxjs';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule, MatCardModule, MatFormFieldModule, MatIconModule, MatInputModule, MatMenuModule, MatProgressSpinnerModule, MatSelectModule, MatToolbarModule, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule, MatDividerModule } from '@angular/material';
import * as moment_ from 'moment';
import 'moment-timezone';
import * as Highcharts from 'highcharts';
import { setOptions, chart } from 'highcharts';
import HighchartsNoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsMore from 'highcharts/highcharts-more';
import StreamgraphModule from 'highcharts/modules/streamgraph.src';
import SunburstModule from 'highcharts/modules/sunburst';
import HeatmapModule from 'highcharts/modules/heatmap';
import ___default, { isPlainObject, isArray, assign, range, reduce, map, find } from 'lodash';
import { catchError, map as map$1, switchMap, filter, finalize, share } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { __read, __spread } from 'tslib';
import { Injectable, NgModule, Component, Input, Output, EventEmitter, ViewChild, defineInjectable, Inject } from '@angular/core';
import { Router } from '@angular/router';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ExLibraryService = /** @class */ (function () {
    function ExLibraryService() {
    }
    ExLibraryService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ExLibraryService.ctorParameters = function () { return []; };
    /** @nocollapse */ ExLibraryService.ngInjectableDef = defineInjectable({ factory: function ExLibraryService_Factory() { return new ExLibraryService(); }, token: ExLibraryService, providedIn: "root" });
    return ExLibraryService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ExLibraryComponent = /** @class */ (function () {
    function ExLibraryComponent() {
    }
    /**
     * @return {?}
     */
    ExLibraryComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ExLibraryComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-ex-library',
                    template: "\n    <p>\n      ex-library works!\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    ExLibraryComponent.ctorParameters = function () { return []; };
    return ExLibraryComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ExLibraryModule = /** @class */ (function () {
    function ExLibraryModule() {
    }
    ExLibraryModule.decorators = [
        { type: NgModule, args: [{
                    imports: [],
                    declarations: [ExLibraryComponent],
                    exports: [ExLibraryComponent]
                },] }
    ];
    return ExLibraryModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaterialDynamicFormsComponent = /** @class */ (function () {
    function MaterialDynamicFormsComponent() {
    }
    /**
     * @return {?}
     */
    MaterialDynamicFormsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    MaterialDynamicFormsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-material-dynamic-forms',
                    template: "\n    <p>\n      material-dynamic-forms works!\n      <mat-card>\n        <mat-card-content>\n          Testing card!\n        </mat-card-content>\n      </mat-card>\n    </p>\n  "
                }] }
    ];
    /** @nocollapse */
    MaterialDynamicFormsComponent.ctorParameters = function () { return []; };
    return MaterialDynamicFormsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var QuestionsTreeElementComponent = /** @class */ (function () {
    function QuestionsTreeElementComponent() {
    }
    /**
     * @return {?}
     */
    QuestionsTreeElementComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    QuestionsTreeElementComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-questions-tree-element',
                    template: "<div [fxLayout]=\"questionTreeElem.fxLayout\" [fxLayoutAlign]=\"questionTreeElem.fxLayoutAlign\" [fxFlex]=\"questionTreeElem.flex\">\r\n  <ng-container *ngIf=\"questionTreeElem.children && questionTreeElem.children.length\">\r\n    <exlib-questions-tree-element *ngFor=\"let elem of questionTreeElem.children\" [questionTreeElem]=\"elem\"\r\n                                  [fxLayout]=\"questionTreeElem.fxLayout\"\r\n                                  [fxLayoutAlign]=\"questionTreeElem.fxLayoutAlign\"\r\n                                  [fxFlex]=\"questionTreeElem.flex\"></exlib-questions-tree-element>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"questionTreeElem.questions && questionTreeElem.questions.length\">\r\n    <p *ngFor=\"let question of questionTreeElem.questions\">\r\n      {{question}}\r\n    </p>\r\n  </ng-container>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    QuestionsTreeElementComponent.ctorParameters = function () { return []; };
    QuestionsTreeElementComponent.propDecorators = {
        questionTreeElem: [{ type: Input }]
    };
    return QuestionsTreeElementComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MatFromsModule = /** @class */ (function () {
    function MatFromsModule() {
    }
    MatFromsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatButtonModule,
                        MatCardModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSelectModule,
                        MatMenuModule,
                    ],
                    exports: [
                        MatButtonModule,
                        MatButtonModule,
                        MatCardModule,
                        MatFormFieldModule,
                        MatInputModule,
                        MatIconModule,
                        MatProgressSpinnerModule,
                        MatToolbarModule,
                        MatSelectModule,
                        MatMenuModule,
                    ],
                    declarations: []
                },] }
    ];
    return MatFromsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var MaterialDynamicFormsModule = /** @class */ (function () {
    function MaterialDynamicFormsModule() {
    }
    MaterialDynamicFormsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        FlexLayoutModule,
                        MatFromsModule,
                    ],
                    declarations: [
                        MaterialDynamicFormsComponent,
                        QuestionsTreeElementComponent,
                    ],
                    exports: [
                        MaterialDynamicFormsComponent,
                        QuestionsTreeElementComponent
                    ]
                },] }
    ];
    return MaterialDynamicFormsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var HttpErrorsUtilsService = /** @class */ (function () {
    function HttpErrorsUtilsService() {
    }
    /**
     * @param {?} resError
     * @return {?}
     */
    HttpErrorsUtilsService.prototype.mapErrorData = /**
     * @param {?} resError
     * @return {?}
     */
    function (resError) {
        if (!isPlainObject(resError) || resError.status === 500) {
            return 'Something went wrong, please try again!';
        }
        if (!!resError.detail) {
            return resError.detail;
        }
        return resError;
    };
    HttpErrorsUtilsService.decorators = [
        { type: Injectable }
    ];
    return HttpErrorsUtilsService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var HttpErrorInterceptor = /** @class */ (function () {
    function HttpErrorInterceptor(httpErrorUtils) {
        this.httpErrorUtils = httpErrorUtils;
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    HttpErrorInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        return next.handle(req).pipe(catchError(this.onError.bind(this)));
    };
    /**
     * @param {?} errorRes
     * @return {?}
     */
    HttpErrorInterceptor.prototype.onError = /**
     * @param {?} errorRes
     * @return {?}
     */
    function (errorRes) {
        var /** @type {?} */ mappedError = this.httpErrorUtils.mapErrorData(errorRes.error);
        var /** @type {?} */ mappedErrorRes = assign({}, errorRes, {
            error: mappedError
        });
        return throwError(mappedErrorRes);
    };
    HttpErrorInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    HttpErrorInterceptor.ctorParameters = function () { return [
        { type: HttpErrorsUtilsService }
    ]; };
    return HttpErrorInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ErrorTreeElementComponent = /** @class */ (function () {
    function ErrorTreeElementComponent() {
    }
    /**
     * @return {?}
     */
    ErrorTreeElementComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ErrorTreeElementComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-error-tree-element',
                    template: "<div [class]=\"errorTreeElement.id === 'main' ? '' : 'm-l'\">\r\n  <ng-container *ngIf=\"errorTreeElement.id !== 'main'\">\r\n    {{errorTreeElement.id}}\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"errorTreeElement.children\">\r\n    <exlib-error-tree-element *ngFor=\"let errorElem of errorTreeElement.children\" [errorTreeElement]=\"errorElem\"></exlib-error-tree-element>\r\n  </ng-container>\r\n\r\n  <ng-container *ngIf=\"errorTreeElement.errors\">\r\n    <ul class=\"no-m\">\r\n      <li *ngFor=\"let errorMessage of errorTreeElement.errors\">\r\n        {{errorMessage}}\r\n      </li>\r\n    </ul>\r\n  </ng-container>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ErrorTreeElementComponent.ctorParameters = function () { return []; };
    ErrorTreeElementComponent.propDecorators = {
        errorTreeElement: [{ type: Input }]
    };
    return ErrorTreeElementComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ErrorsComponent = /** @class */ (function () {
    function ErrorsComponent() {
    }
    Object.defineProperty(ErrorsComponent.prototype, "error", {
        set: /**
         * @param {?} error
         * @return {?}
         */
        function (error) {
            if (isPlainObject(error) && error.status !== 500) {
                var /** @type {?} */ flattenErr = this.flattenMessages(error);
                /**
                       * @todo remove the line below if there is no need
                       * for element tree
                       */
                // this.errorTree = (error as ErrorTreeItem);
                this.errorsObj = flattenErr;
                this.errorsKeys = Object.keys(flattenErr);
            }
            else if (isPlainObject(error) && error.status === 500) {
                this.errorMessage = 'Sorry something went worng! please try again';
            }
            else {
                this.errorMessage = (/** @type {?} */ (error));
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    ErrorsComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} errorObj
     * @param {?=} obj
     * @param {?=} curry
     * @return {?}
     */
    ErrorsComponent.prototype.flattenMessages = /**
     * @param {?} errorObj
     * @param {?=} obj
     * @param {?=} curry
     * @return {?}
     */
    function (errorObj, obj, curry) {
        var _this = this;
        if (obj === void 0) { obj = {}; }
        if (curry === void 0) { curry = ''; }
        var /** @type {?} */ keys = isPlainObject(errorObj) ? Object.keys(errorObj) : [];
        keys.forEach(function (key) {
            var /** @type {?} */ isAr = isArray(errorObj[key]);
            if (isAr) {
                obj[curry + key] = errorObj[key];
            }
            else {
                _this.flattenMessages(errorObj[key], obj, curry + key + '.');
            }
        });
        return obj;
    };
    ErrorsComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-errors',
                    template: "<div class=\"error\">\r\n  <div class=\"error__title\">\r\n    <ng-content></ng-content>\r\n  </div>\r\n\r\n  <div class=\"error__content\" *ngIf=\"errorMessage\">\r\n    <div class=\"error__message\" *ngIf=\"errorMessage\">\r\n      {{errorMessage}}\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"error__content\" *ngIf=\"errorsObj\">\r\n    <div class=\"error__message\" *ngFor=\"let key of errorsKeys\">\r\n      <b>{{labels[key] || (key[0].toUpperCase() + key.slice(1))}}: </b>\r\n      <ng-container *ngFor=\"let msg of errorsObj[key]; let i = index\">\r\n        <br *ngIf=\"i > 0\">{{msg}}\r\n      </ng-container>\r\n    </div>\r\n  </div>\r\n</div>\r\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ErrorsComponent.ctorParameters = function () { return []; };
    ErrorsComponent.propDecorators = {
        labels: [{ type: Input }],
        error: [{ type: Input }]
    };
    return ErrorsComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var HttpErrorsModule = /** @class */ (function () {
    function HttpErrorsModule() {
    }
    HttpErrorsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [ErrorsComponent, ErrorTreeElementComponent],
                    exports: [ErrorsComponent, ErrorTreeElementComponent],
                    providers: [
                        HttpErrorsUtilsService,
                    ]
                },] }
    ];
    return HttpErrorsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var SelectFilesComponent = /** @class */ (function () {
    function SelectFilesComponent() {
        this.selectFiles = new EventEmitter();
    }
    /**
     * @return {?}
     */
    SelectFilesComponent.prototype.openSelector = /**
     * @return {?}
     */
    function () {
        this.fileInput.nativeElement.click();
    };
    /**
     * @return {?}
     */
    SelectFilesComponent.prototype.onFilesAdded = /**
     * @return {?}
     */
    function () {
        this.selectFiles.emit(this.fileInput.nativeElement.files);
    };
    SelectFilesComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-select-files',
                    template: "<input type=\"file\" #fileInput style=\"display: none\" (change)=\"onFilesAdded()\" [accept]=\"acceptedFormats\"/>"
                }] }
    ];
    SelectFilesComponent.propDecorators = {
        acceptedFormats: [{ type: Input }],
        selectFiles: [{ type: Output }],
        fileInput: [{ type: ViewChild, args: ['fileInput',] }]
    };
    return SelectFilesComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UploadFileModalComponent = /** @class */ (function () {
    function UploadFileModalComponent(dialogRef, modalData, toastr, fileSaver) {
        this.dialogRef = dialogRef;
        this.modalData = modalData;
        this.toastr = toastr;
        this.fileSaver = fileSaver;
        this.subscription = new Subscription();
    }
    /**
     * @param {?} files
     * @return {?}
     */
    UploadFileModalComponent.prototype.onFileSelected = /**
     * @param {?} files
     * @return {?}
     */
    function (files) {
        if (!files.length)
            return;
        this.selectedFile = files[0];
    };
    /**
     * @return {?}
     */
    UploadFileModalComponent.prototype.upload = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.uploading = true;
        var /** @type {?} */ uploadFileEvents$ = this.modalData.uploadMethod(this.selectedFile).pipe(share());
        this.trackProgress(uploadFileEvents$);
        var /** @type {?} */ uploadSubscription = uploadFileEvents$
            .pipe(filter(function (event) { return event.type === HttpEventType.Response; }), finalize(function () { return _this.uploading = false; }))
            .subscribe(function (res) { return _this.onUploadingFinished(res); });
        this.subscription.add(uploadSubscription);
    };
    /**
     * @param {?} upload$
     * @return {?}
     */
    UploadFileModalComponent.prototype.trackProgress = /**
     * @param {?} upload$
     * @return {?}
     */
    function (upload$) {
        var _this = this;
        this.uploadingProgress$ = upload$.pipe(map$1(function (event) { return _this.handleUploadEventProgress(/** @type {?} */ (event), _this.selectedFile); }), share());
    };
    /**
     * @param {?} res
     * @return {?}
     */
    UploadFileModalComponent.prototype.onUploadingFinished = /**
     * @param {?} res
     * @return {?}
     */
    function (res) {
        var _this = this;
        this.processing = true;
        var /** @type {?} */ pollerStart = (this.modalData.pollerStartInSec || 0) * 1000;
        var /** @type {?} */ pollerPeriod = (this.modalData.pollerPeriodInSec || 1) * 1000;
        this.importingProgress$ = timer(pollerStart, pollerPeriod).pipe(switchMap(function () { return _this.checkImportingProgress(res.body.task_id); }), share(), finalize(function () { return _this.processing = false; }));
        var /** @type {?} */ statusSubscription = this.importingProgress$.subscribe(function (status) {
            if (!status.done)
                return;
            _this.toastr.success(_this.selectedFile.name + " imported successfully!") && _this.close();
        }, function (error) { return _this.toastr.error("Importing " + _this.selectedFile.name + " Failed!"); });
        this.subscription.add(statusSubscription);
    };
    /**
     * @param {?} event
     * @param {?} file
     * @return {?}
     */
    UploadFileModalComponent.prototype.handleUploadEventProgress = /**
     * @param {?} event
     * @param {?} file
     * @return {?}
     */
    function (event, file) {
        switch (event.type) {
            case HttpEventType.Sent:
                return { started: true };
            case HttpEventType.UploadProgress:
                var /** @type {?} */ percentDone = Math.round(100 * event.loaded / event.total);
                return { started: true, progress: percentDone };
            case HttpEventType.Response:
                return { started: true, progress: 100, finished: true };
        }
    };
    /**
     * @param {?} taskId
     * @return {?}
     */
    UploadFileModalComponent.prototype.checkImportingProgress = /**
     * @param {?} taskId
     * @return {?}
     */
    function (taskId) {
        return this.modalData.importingProgress(taskId).pipe(map$1(function (res) {
            if (res.status === 'FAILURE')
                throw new Error();
            return assign({}, res, {
                started: true,
                done: res.status === 'SUCCESS',
            });
        }));
    };
    /**
     * @return {?}
     */
    UploadFileModalComponent.prototype.downloadTemplate = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.modalData.templateMethod()
            .subscribe(function (res) { return _this.fileSaver.save(res.blob, res.name); });
    };
    /**
     * @return {?}
     */
    UploadFileModalComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        this.subscription.unsubscribe();
        this.dialogRef.close();
    };
    UploadFileModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-upload-file-modal',
                    template: "<h3 mat-dialog-title class=\"mat-h3\">{{modalData.title}}</h3>\r\n\r\n<div mat-dialog-content>\r\n  <div class=\"m-b\">\r\n\r\n    <exlib-select-files (selectFiles)=\"onFileSelected($event)\"\r\n                        [acceptedFormats]=\"modalData.acceptedFileFormats\"></exlib-select-files>\r\n\r\n    <div class=\"info-frame m-b\" fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"5px\" *ngIf=\"!!modalData.templateMethod\">\r\n      <mat-icon class=\"mat-primary\">info</mat-icon>\r\n      <div>You can download <a href=\"javascript:void(0)\" (click)=\"downloadTemplate()\" class=\"pointer\">template here</a></div>\r\n    </div>\r\n\r\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\">\r\n      <button mat-button mat-raised-button class=\"mat-primary\" (click)=\"selectFilesComponent.openSelector()\">Select File</button>\r\n      <div *ngIf=\"selectedFile\">{{selectedFile.name}}</div>\r\n    </div>\r\n\r\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" *ngIf=\"(uploadingProgress$ | async)?.started && !(uploadingProgress$ | async)?.finished\" class=\"m-t\">\r\n      <div fxFlex=\"35\" fxLayoutAlign=\"center center\">\r\n        <mat-progress-spinner\r\n          class=\"mat-primary\"\r\n          mode=\"determinate\"\r\n          diameter=\"20\"\r\n          [value]=\"(uploadingProgress$ | async)?.progress\">\r\n        </mat-progress-spinner>\r\n      </div>\r\n      <div fxFlex=\"65\" fxLayoutAlign=\"start center\">\r\n        Uploading {{(uploadingProgress$ | async)?.progress}} %\r\n      </div>\r\n    </div>\r\n\r\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" *ngIf=\"processing\" class=\"m-t\">\r\n      <div fxFlex=\"35\" fxLayoutAlign=\"center center\">\r\n        <mat-progress-spinner\r\n          class=\"mat-primary\"\r\n          mode=\"indeterminate\"\r\n          diameter=\"20\">\r\n        </mat-progress-spinner>\r\n      </div>\r\n      <div fxFlex=\"65\" fxLayoutAlign=\"start center\">\r\n        Processing...\r\n      </div>\r\n    </div>\r\n\r\n  </div>\r\n</div>\r\n\r\n<mat-divider></mat-divider>\r\n\r\n<div mat-dialog-actions fxLayout=\"row\" fxLayoutAlign=\"end center\" fxLayoutGap=\"10px\">\r\n  <button mat-raised-button (click)=\"close()\">Cancel</button>\r\n  <button mat-raised-button  (click)=\"upload()\" class=\"mat-primary\" [disabled]=\"!selectedFile || uploading\">Upload</button>\r\n</div>\r\n"
                }] }
    ];
    /** @nocollapse */
    UploadFileModalComponent.ctorParameters = function () { return [
        { type: MatDialogRef },
        { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
        { type: ToastrService },
        { type: FileSaverService }
    ]; };
    UploadFileModalComponent.propDecorators = {
        selectFilesComponent: [{ type: ViewChild, args: [SelectFilesComponent,] }]
    };
    return UploadFileModalComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UploadFilesModule = /** @class */ (function () {
    function UploadFilesModule() {
    }
    UploadFilesModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        MatDialogModule,
                        MatDividerModule,
                        MatButtonModule,
                        MatProgressSpinnerModule,
                        MatIconModule,
                        FlexLayoutModule,
                        ToastrModule.forRoot(),
                    ],
                    declarations: [SelectFilesComponent, UploadFileModalComponent],
                    exports: [SelectFilesComponent, UploadFileModalComponent],
                    entryComponents: [UploadFileModalComponent],
                },] }
    ];
    return UploadFilesModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IntermediateActionComponent = /** @class */ (function () {
    function IntermediateActionComponent() {
    }
    IntermediateActionComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-intermediate-action',
                    template: "\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" *ngIf=\"actionFlag\" class=\"m-t\">\n      <div fxFlex=\"35\" fxLayoutAlign=\"center center\">\n        <mat-progress-spinner\n          class=\"mat-primary\"\n          mode=\"indeterminate\"\n          diameter=\"20\">\n        </mat-progress-spinner>\n      </div>\n      <div fxFlex=\"65\" fxLayoutAlign=\"start center\">\n        {{actionMessage}}...\n      </div>\n    </div>\n  "
                }] }
    ];
    /** @nocollapse */
    IntermediateActionComponent.ctorParameters = function () { return []; };
    IntermediateActionComponent.propDecorators = {
        actionFlag: [{ type: Input }],
        actionMessage: [{ type: Input }]
    };
    return IntermediateActionComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var UploadPercentageComponent = /** @class */ (function () {
    function UploadPercentageComponent() {
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    UploadPercentageComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (!!changes["upload$"].currentValue)
            this.trackProgress();
    };
    /**
     * @return {?}
     */
    UploadPercentageComponent.prototype.trackProgress = /**
     * @return {?}
     */
    function () {
        this.uploadingProgress$ = this.upload$.pipe(map$1(function (event) { return UploadPercentageComponent.handleUploadEventProgress(/** @type {?} */ (event)); }), share());
    };
    /**
     * @param {?} event
     * @return {?}
     */
    UploadPercentageComponent.handleUploadEventProgress = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        switch (event.type) {
            case HttpEventType.Sent:
                return { started: true };
            case HttpEventType.UploadProgress:
                var /** @type {?} */ percentDone = Math.round(100 * event.loaded / event.total);
                return { started: true, progress: percentDone };
            case HttpEventType.Response:
                return { started: true, progress: 100, finished: true };
        }
    };
    UploadPercentageComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-upload-percentage',
                    template: "\n    <div fxLayout=\"row\" fxLayoutAlign=\"start center\" fxLayoutGap=\"10px\" *ngIf=\"(uploadingProgress$ | async)?.started && !(uploadingProgress$ | async)?.finished\" class=\"m-t\">\n      <div fxFlex=\"35\" fxLayoutAlign=\"center center\">\n        <mat-progress-spinner\n          class=\"mat-primary\"\n          mode=\"determinate\"\n          diameter=\"20\"\n          [value]=\"(uploadingProgress$ | async)?.progress\">\n        </mat-progress-spinner>\n      </div>\n      <div fxFlex=\"65\" fxLayoutAlign=\"start center\">\n        Uploading {{(uploadingProgress$ | async)?.progress}} %\n      </div>\n    </div>\n  "
                }] }
    ];
    /** @nocollapse */
    UploadPercentageComponent.ctorParameters = function () { return []; };
    UploadPercentageComponent.propDecorators = {
        upload$: [{ type: Input }]
    };
    return UploadPercentageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var IndicatorsModule = /** @class */ (function () {
    function IndicatorsModule() {
    }
    IndicatorsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        MatProgressSpinnerModule,
                        FlexLayoutModule,
                    ],
                    declarations: [UploadPercentageComponent, IntermediateActionComponent],
                    exports: [UploadPercentageComponent, IntermediateActionComponent],
                },] }
    ];
    return IndicatorsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ chartOptionDefault = {
    backgroundColor: null,
    style: {
        fontFamily: 'Roboto',
    }
};
var /** @type {?} */ chartDefaultOptions = {
    chart: chartOptionDefault,
    title: {
        text: null,
    },
    credits: {
        enabled: false,
    },
    colors: [
        '#CC6666',
        '#FF9999',
        '#999999',
        '#666666',
        '#FF3366',
        '#FFCC99',
        '#99CC66',
        '#99CC99',
        '#FF66CC',
        '#000066',
        '#CC99FF',
        '#993399',
        '#FF9966',
        '#CC9966',
        '#996633',
        '#0066CC',
        '#99CCFF',
        '#99CCCC',
        '#666699',
        '#9966FF',
        '#99FF66',
        '#33CC33',
        '#FF00FF',
        '#CC66CC',
        '#CC3366',
        '#66CC99',
        '#993366',
        '#CC3399',
        '#FF33CC',
        '#0000CC',
        '#CC99CC',
        '#00FF00',
        '#66CCCC',
        '#0099FF',
        '#33CCCC',
        '#00FF99',
        '#6666FF',
        '#9999FF',
        '#9966CC',
        '#CC0099',
        '#FFCCCC',
        '#FF6666',
        '#CCCC99',
        '#996666',
        '#999966',
        '#66FF00',
        '#FF9900',
        '#669933',
        '#99CC33',
        '#FF3300',
        '#990099',
        '#FF0089',
        '#9900CC',
        '#990066',
        '#EE82EE',
        '#CC33CC',
        '#CCCC66',
        '#FFFF99',
        '#FFCC00',
        '#FFFF00',
        '#330099',
        '#6633CC',
        '#333399',
        '#3366CC',
        '#00CCFF',
        '#00CCCC',
        '#66FFCC',
        '#99FFFF',
        '#0033FF',
        '#339999',
        '#CC6600',
        '#66CC00',
        '#33FF33',
        '#99FF33',
        '#33FF99',
        '#CCCCCC',
        '#99FF99',
        '#33CC66',
        '#339966',
        '#006699',
        '#CC3333',
        '#CC9933',
        '#FF0000',
        '#FFCC66',
        '#FFCC33',
        '#CC6633',
        '#33CC99',
        '#CC9999',
        '#CC6699',
        '#9999CC',
        '#00CC33',
        '#3399FF',
        '#0099CC',
        '#3366FF',
        '#FF33FF',
        '#9933CC',
        '#CC00FF',
        '#3399CC',
        '#669999',
        '#663366',
    ],
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ moment = moment_;
/**
 * @param {?} momentTime
 * @return {?}
 */
function getDayName(momentTime) {
    return "<br><span>" + momentTime.format('dddd') + "</span>";
}
/**
 * @param {?=} timezone
 * @return {?}
 */
function tooltipDatetimeFormatterFactory(timezone) {
    return function (datetimeVal) {
        var /** @type {?} */ momentTime = timezone ? moment(datetimeVal).tz(timezone) : moment.utc(datetimeVal);
        return "<span>" + momentTime.format('l') + ", " + momentTime.format('LT') + "</span>";
    };
}
/**
 * @param {?=} timezone
 * @return {?}
 */
function tooltipDateOnlyFormatterFactory(timezone) {
    return function (datetimeVal) {
        var /** @type {?} */ momentTime = timezone ? moment(datetimeVal).tz(timezone) : moment.utc(datetimeVal);
        return "<span>" + momentTime.format('l') + "</span>";
    };
}
/**
 * @param {?=} timezone
 * @return {?}
 */
function dateOnlyLabelFormatterFactory(timezone) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var /** @type {?} */ momentTime = timezone ? moment(this.value).tz(timezone) : moment.utc(this.value);
        return "<span>" + momentTime.format('l') + "</span>";
    };
}
/**
 * @param {?=} timezone
 * @param {?=} withDayName
 * @return {?}
 */
function datetimeLabelFormatterFactory(timezone, withDayName) {
    if (withDayName === void 0) { withDayName = false; }
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var /** @type {?} */ momentTime = timezone ? moment(this.value).tz(timezone) : moment.utc(this.value);
        return "<span>" + momentTime.format('LT') + "</span>\n            <br>\n            <span>" + momentTime.format('l') + "</span>\n            " + (withDayName ? getDayName(momentTime) : '');
    };
}
/**
 * @param {?} timeRange
 * @param {?} dataArr
 * @param {?=} pointDimensions
 * @return {?}
 */
function fixTimeRange(timeRange, dataArr, pointDimensions) {
    if (pointDimensions === void 0) { pointDimensions = 2; }
    if (!dataArr.length) {
        return dataArr;
    }
    var /** @type {?} */ isRaw = timeRange.resolution === 'raw';
    var _a = __read(isRaw ? [null, 0, 's'] : timeRange.resolution.match(/(\d+)(\w)/), 3), resolutionVal = _a[1], resolutionUnit = _a[2];
    var _b = __read(timeRange.offset ? timeRange.offset.match(/(\d+)(\w)/) : [null, 0, 's'], 3), offsetVal = _b[1], offsetUnit = _b[2];
    var _c = __read(_getTimeBoundaries(timeRange, resolutionVal, resolutionUnit, offsetVal, offsetUnit), 2), startTime = _c[0], endTime = _c[1];
    var /** @type {?} */ startPoint = _generateNullDataPoint(startTime.subtract(1, 's'), pointDimensions);
    var /** @type {?} */ endPoint = _generateNullDataPoint(endTime.add(1, 's'), pointDimensions);
    return [startPoint].concat(dataArr, [endPoint]);
}
/**
 * @param {?} time
 * @param {?=} pointDimensions
 * @return {?}
 */
function _generateNullDataPoint(time, pointDimensions) {
    if (pointDimensions === void 0) { pointDimensions = 2; }
    var /** @type {?} */ rangeToFill = range(pointDimensions - 1);
    return reduce(rangeToFill, function (pointArr) { return pointArr.push(null) && pointArr; }, [moment(time).toDate().valueOf()]);
}
/**
 * @param {?} timeRange
 * @param {?} dataArr
 * @param {?=} pointDimensions
 * @return {?}
 */
function fillDataArr(timeRange, dataArr, pointDimensions) {
    if (pointDimensions === void 0) { pointDimensions = 2; }
    var _a = __read(timeRange.resolution.match(/(\d+)(\w)/), 3), resolutionVal = _a[1], resolutionUnit = _a[2];
    var _b = __read(timeRange.offset ? timeRange.offset.match(/(\d+)(\w)/) : [null, 0, 's'], 3), offsetVal = _b[1], offsetUnit = _b[2];
    var _c = __read(_getTimeBoundaries(timeRange, resolutionVal, resolutionUnit, offsetVal, offsetUnit), 2), startTimePoint = _c[0], endTimePoint = _c[1];
    var /** @type {?} */ timesArr = _constructTimesArr(startTimePoint, endTimePoint, resolutionVal, resolutionUnit);
    return _mapDataArr(dataArr, timesArr, resolutionUnit, pointDimensions);
}
/**
 * @param {?} timeRange
 * @param {?} resolutionVal
 * @param {?} resolutionUnit
 * @param {?} offsetVal
 * @param {?} offsetUnit
 * @return {?}
 */
function _getTimeBoundaries(timeRange, resolutionVal, resolutionUnit, offsetVal, offsetUnit) {
    var /** @type {?} */ startTimeMoment = moment(timeRange.start_time);
    var /** @type {?} */ endTimeMoment = moment(timeRange.end_time);
    var /** @type {?} */ startTimeReminder = resolutionVal - startTimeMoment.get(resolutionUnit) % resolutionVal;
    var /** @type {?} */ endTimeReminder = resolutionVal - endTimeMoment.get(resolutionUnit) % resolutionVal;
    var /** @type {?} */ expectedFirstPoint = startTimeMoment
        .startOf(resolutionUnit)
        .add(startTimeReminder, resolutionUnit)
        .add(offsetVal, offsetUnit);
    var /** @type {?} */ expectedLastPoint = endTimeMoment
        .startOf(resolutionUnit)
        .add(endTimeReminder, resolutionUnit)
        .add(offsetVal, offsetUnit);
    var /** @type {?} */ startTimePoint = startTimeMoment.isSameOrBefore(expectedFirstPoint)
        ? expectedFirstPoint
        : expectedFirstPoint.clone().add(resolutionVal, resolutionUnit);
    var /** @type {?} */ endTimePoint = endTimeMoment.isSameOrBefore(expectedLastPoint)
        ? expectedLastPoint
        : expectedLastPoint.clone().subtract(resolutionVal, resolutionUnit);
    return [startTimePoint, endTimePoint];
}
/**
 * @param {?} startTimePoint
 * @param {?} endTimePoint
 * @param {?} resolutionVal
 * @param {?} resolutionUnit
 * @return {?}
 */
function _constructTimesArr(startTimePoint, endTimePoint, resolutionVal, resolutionUnit) {
    var /** @type {?} */ timesArr = [startTimePoint];
    var /** @type {?} */ nextTimePoint = null;
    var /** @type {?} */ updateNextTimePoint = function () { return nextTimePoint = (nextTimePoint || startTimePoint).clone().add(resolutionVal, resolutionUnit); };
    updateNextTimePoint();
    while (nextTimePoint.isBefore(endTimePoint)) {
        timesArr.push(nextTimePoint);
        updateNextTimePoint();
    }
    return timesArr;
}
/**
 * @param {?} dataArr
 * @param {?} timesArr
 * @param {?} resolutionUnit
 * @param {?} dataPointDimensions
 * @return {?}
 */
function _mapDataArr(dataArr, timesArr, resolutionUnit, dataPointDimensions) {
    var /** @type {?} */ timeValuesArr = map(timesArr, function (m) { return m.utc().toDate().valueOf(); });
    return map(timeValuesArr, function (timeVal) {
        var /** @type {?} */ dataPoint = find(dataArr, function (p) { return moment(timeVal).isSame(p[0], resolutionUnit); });
        if (dataPoint) {
            return dataPoint;
        }
        var /** @type {?} */ rangeToFill = range(dataPointDimensions - 1);
        return reduce(rangeToFill, function (pointArr) { return pointArr.push(null) && pointArr; }, [timeVal]);
    });
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
setOptions(chartDefaultOptions);
HighchartsNoDataToDisplay(Highcharts);
HighchartsMore(Highcharts);
StreamgraphModule(Highcharts);
SunburstModule(Highcharts);
HeatmapModule(Highcharts);
var ChartComponent = /** @class */ (function () {
    function ChartComponent() {
        this.chartRendered = new EventEmitter();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ChartComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (!!changes["chartOptions"].currentValue) {
            this.renderChart();
        }
    };
    /**
     * @return {?}
     */
    ChartComponent.prototype.renderChart = /**
     * @return {?}
     */
    function () {
        var _this = this;
        setTimeout(function () {
            _this.chart = chart(_this.chartElem.nativeElement, _this.chartOptions);
            _this.chartRendered.emit(_this.chart);
        }, 500);
    };
    ChartComponent.decorators = [
        { type: Component, args: [{
                    selector: 'exlib-chart',
                    template: "\n    <div #chartElem></div>\n  "
                }] }
    ];
    /** @nocollapse */
    ChartComponent.ctorParameters = function () { return []; };
    ChartComponent.propDecorators = {
        chartOptions: [{ type: Input }],
        chartRendered: [{ type: Output }],
        chartElem: [{ type: ViewChild, args: ['chartElem',] }]
    };
    return ChartComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var ChartsModule = /** @class */ (function () {
    function ChartsModule() {
    }
    ChartsModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    exports: [ChartComponent],
                    declarations: [ChartComponent]
                },] }
    ];
    return ChartsModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var /** @type {?} */ pageSizeParam = 'pageSize';
var /** @type {?} */ pageParam = 'page';
var PaginationInterceptor = /** @class */ (function () {
    function PaginationInterceptor() {
    }
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    PaginationInterceptor.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        var /** @type {?} */ mappedReq = this.mapReq(req);
        return next.handle(mappedReq).pipe(map$1(function (res) { return _this.mapResponse(req, /** @type {?} */ (res)); }));
    };
    /**
     * @param {?} req
     * @return {?}
     */
    PaginationInterceptor.prototype.mapReq = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        var /** @type {?} */ reqParams = req.params;
        if (!reqParams.has(pageParam)) {
            return req;
        }
        var /** @type {?} */ pageSize = Number(reqParams.get(pageSizeParam));
        var /** @type {?} */ page = Number(reqParams.get(pageParam));
        var /** @type {?} */ offset = pageSize * (page - 1);
        var /** @type {?} */ updatedParams = reqParams
            .delete(pageSizeParam)
            .delete(pageParam)
            .set('limit', pageSize.toString())
            .set('offset', offset.toString());
        return req.clone({
            params: updatedParams,
        });
    };
    /**
     * @param {?} req
     * @param {?} res
     * @return {?}
     */
    PaginationInterceptor.prototype.mapResponse = /**
     * @param {?} req
     * @param {?} res
     * @return {?}
     */
    function (req, res) {
        var /** @type {?} */ count = ___default.get(res.body, 'count');
        if (___default.isUndefined(count)) {
            return res;
        }
        var /** @type {?} */ pageSize = Number(req.params.get(pageSizeParam));
        var /** @type {?} */ updatedBody = ___default.assign({}, res.body, {
            page: req.params.get(pageParam),
            pageSize: pageSize,
            pages: ___default.ceil(count / pageSize),
        });
        return res.clone({
            body: updatedBody,
        });
    };
    PaginationInterceptor.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    PaginationInterceptor.ctorParameters = function () { return []; };
    return PaginationInterceptor;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
var PaginationInterceptorModule = /** @class */ (function () {
    function PaginationInterceptorModule() {
    }
    PaginationInterceptorModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [],
                    providers: [PaginationInterceptor],
                },] }
    ];
    return PaginationInterceptorModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
IAuthService = /** @class */ (function () {
    function IAuthService() {
    }
    return IAuthService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * UserGroupGaurd
 * guard to check whether the route is available for current user or not.
 * depending on group: ['role1', 'role2', 'role3'].
 * and route must have data: {
 *   availableForGroup: ['role1', 'role2' ],
 *   notAvailableRedirect: '/somurl',
 * }
 */
var UserGroupGuard = /** @class */ (function () {
    function UserGroupGuard(auth, router) {
        this.auth = auth;
        this.router = router;
        // this will enable every thing to user
        // that has group['superuser']
        this.adminRole = 'superuser';
        // this key `group` will be accessed in user
        // to get array of roles of user. `user.group`
        this.userGroupKey = 'group';
        // method name in AuthService that returns the user object.
        this.getUserMethodNameInAuth = 'getUser';
    }
    Object.defineProperty(UserGroupGuard.prototype, "user", {
        get: /**
         * @return {?}
         */
        function () {
            return this.auth[this.getUserMethodNameInAuth]();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserGroupGuard.prototype, "group", {
        get: /**
         * @return {?}
         */
        function () {
            var /** @type {?} */ user = this.user || {};
            return user[this.userGroupKey] || [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserGroupGuard.prototype, "isAdmin", {
        get: /**
         * @return {?}
         */
        function () {
            return this.group.indexOf(this.adminRole) > -1;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    UserGroupGuard.prototype.canActivate = /**
     * @param {?} next
     * @param {?} state
     * @return {?}
     */
    function (next, state) {
        var /** @type {?} */ group = __spread(((next.data && next.data["availableForGroup"]) || []));
        var /** @type {?} */ redirect = (next.data && next.data["notAvailableRedirect"]) || next.url[0];
        var /** @type {?} */ allowed = this.isAdmin || this.isAllowed(group);
        if (!allowed) {
            this.router.navigateByUrl(redirect);
        }
        return allowed;
    };
    /**
     * @param {?=} routeGroup
     * @return {?}
     */
    UserGroupGuard.prototype.isAllowed = /**
     * @param {?=} routeGroup
     * @return {?}
     */
    function (routeGroup) {
        if (routeGroup === void 0) { routeGroup = []; }
        var group = this.group;
        var /** @type {?} */ allowed = false;
        group.forEach(function (role) {
            if (routeGroup.indexOf(role) > -1) {
                allowed = true;
            }
        });
        return allowed;
    };
    UserGroupGuard.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    UserGroupGuard.ctorParameters = function () { return [
        { type: IAuthService },
        { type: Router }
    ]; };
    return UserGroupGuard;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { ExLibraryService, ExLibraryComponent, ExLibraryModule, MaterialDynamicFormsComponent, QuestionsTreeElementComponent, MaterialDynamicFormsModule, HttpErrorsUtilsService, HttpErrorInterceptor, ErrorTreeElementComponent, ErrorsComponent, HttpErrorsModule, SelectFilesComponent, UploadFileModalComponent, UploadFilesModule, IntermediateActionComponent, UploadPercentageComponent, IndicatorsModule, chartOptionDefault, chartDefaultOptions, tooltipDatetimeFormatterFactory, tooltipDateOnlyFormatterFactory, dateOnlyLabelFormatterFactory, datetimeLabelFormatterFactory, fixTimeRange, _generateNullDataPoint, fillDataArr, ChartComponent, ChartsModule, pageSizeParam, pageParam, PaginationInterceptor, PaginationInterceptorModule, IAuthService, UserGroupGuard, MatFromsModule as ɵa };

//# sourceMappingURL=ex-library.js.map